import {
  InvoiceStatus,
  InvoiceStatus as T,
} from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/enums/invoice-status.enum';

interface GenericInvoiceStatus {
  name: string;
  color: string;
}

export const InvoiceStatusEnum: Record<InvoiceStatus, GenericInvoiceStatus> = {
  DRAFT: {
    name: 'DRAFT',
    color: 'bg-surface-brand-secondary',
  },
  ISSUED: {
    name: 'ISSUED',
    color: 'bg-surface-secondary',
  },
  PAID: {
    name: 'PAID',
    color: 'bg-surface-success',
  },
  CANCELED: {
    name: 'CANCELED',
    color: 'bg-surface-error',
  },
};

export const mapStatusToGenericInvoiceStatus = (
  state: T,
): GenericInvoiceStatus => {
  return (
    InvoiceStatusEnum[state] ?? {
      name: 'UNKNOWN',
      color: 'bg-surface-brand-secondary',
    }
  );
};
